import { DatePipe } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { bulkExcel, Documents, uploadException } from '../../Models/BulkUpload/bulkDocument';
import { LoginService } from '../../services/login/login.service';
import { PagerService } from "src/app/Services/pager.service";
import { MatSnackBarComponent } from "../mat-snack-bar/mat-snack-bar.component";
import { BulkUploadService } from "src/app/Services/bulk-upload/bulk-upload.service";
import * as XLSX from "xlsx";

@Component({
    selector: 'app-bulk-upload',
    templateUrl: './bulk-upload.component.html',
    styleUrls: ['./bulk-upload.component.css'],
    providers: [PagerService, DatePipe]
})

export class BulkUploadComponent implements OnInit {
    userName: string;
    userID:string;
    roleID: string;
    loader: string = 'none';
    files: File[] = [];
    fileName: string = '';
   // document: Documents = new Documents();


     //upload excel
    document: Documents = new Documents();
    IsFileCorrect: boolean;
    arrayBuffer: any;
    filelist: any;
    displayUploadPanel: string = 'none';
    errorExcelUpload: uploadException[] = [];
    afterUpload: bulkExcel[]=[];
    constructor(private bulkUploadService: BulkUploadService, private snackBar: MatSnackBarComponent,
        private _pagerService: PagerService, private datepipe: DatePipe, private router: Router,private toastr: ToastrService,) {
        this.roleID = localStorage.getItem('mcmt_roleID');
        this.userID = localStorage.getItem('mcmt_userId');
        this.userName = localStorage.getItem('mcmt_userName');
    }
   

    @ViewChild('file') input;


    ngOnInit(): void {
        if (sessionStorage.tabID == undefined) {
            this.router.navigate(['/MCMaterial/Login']);
        }
        else{
            
        }
        var someElement= document.getElementById("ancUploadExcel"); 
    }

    excelDownload() {
        this.loader = 'block';
        this.bulkUploadService.DownloadBulkJobCancellationExcel()
          .subscribe(
            success => {
              var date = new Date();
              var latest_date = this.datepipe.transform(date, 'dd-MMM-yy');
              var Name = localStorage.getItem('mcmt_userName').split(' ');
              var Firstname = Name[0];
              var LastName = Name[1];
              let cYear :number;
              cYear=(new Date()).getFullYear();
              var ExcelName = Firstname + '_' + LastName + '_'+ cYear + '_BulkJobCancellation_' + latest_date + '.xlsx';           
              saveAs(success, ExcelName);
             
            },
            err => {
              this.toastr.error("No Records Available.");
              this.loader = 'none';
              console.log(err);
            }
          );
    }


    filesDroppedAdd(files: File[]) {
        this.loader = 'block';
        this.files = [];
        this.files = files;
        let fileNameParts: string[] = files[0].name.split('.');
        let fileType = files[0].name.split('.')[fileNameParts.length - 1];
        let CorrectFileName = '_BulkJobCancellation_';
        if (fileNameParts[0].includes(CorrectFileName)) {
          this.IsFileCorrect = true;
        }
        else {
          this.IsFileCorrect = false;
        }
        if (this.IsFileCorrect == false) {
          this.toastr.error('Please Select Valid File.');
          this.loader = 'none';
          return false;
        }
        if (fileType != 'xls' && fileType != 'xlsx') {
          this.toastr.error('Please Select Valid File Type.');
          this.loader = 'none';
          return false;
        }
        else {
          this.loader = 'block';
          this.document.file = <File>this.files[0];
          let fileReader = new FileReader();
          fileReader.readAsArrayBuffer(<File>this.files[0]);
          fileReader.onload = (e) => {
            this.arrayBuffer = fileReader.result;
            var data = new Uint8Array(this.arrayBuffer);
            var arr = new Array();
            for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
            var bstr = arr.join("");
            var workbook = XLSX.read(bstr, { type: "binary" });
            var first_sheet_name = workbook.SheetNames[0];
            var worksheet = workbook.Sheets[first_sheet_name];
            this.filelist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
            this.displayUploadPanel = 'block';
            this.files = [];
            this.loader = 'none';
            if(this.filelist==''){
              this.toastr.error('No record found in excel');
              this.displayUploadPanel = 'none';
            }
            else{
              this.displayUploadPanel = 'none';
              this.UploadSubmit();
            }

          }
        }
      
    }
    closeUploadPanel() {
        this.displayUploadPanel = 'none';
        this.afterUpload = null;
    }
    UploadSubmit() {
        this.loader = 'block';
        this.bulkUploadService.uploadBulkJobCancellation(this.filelist).subscribe((responseData: any) => { 
          if(responseData.message=='Job numbers cannot be cancelled'){
            this.toastr.error(responseData.message);
            this.displayUploadPanel = 'block'; 
          }
          else if(responseData.message=='Data Uploaded Successfully'){
            this.toastr.success(responseData.message);    
            this.displayUploadPanel = 'none';      
          }
          else if(responseData.message=='Partially Data Uploaded Successfully'){
            this.toastr.success(responseData.message); 
            this.displayUploadPanel = 'block'; 
          }
          else{
            this.toastr.success(responseData.message);
          }
  
          if(responseData.data!=null){
              this.afterUpload=responseData.data;
          }                
          });          
        err=>{
          this.toastr.error('Some error occured while uploading file', 'Close');
          this.loader = 'none';
          this.displayUploadPanel = 'none';
        }  
    }
}
 